import React from "react";
import BubbleEffectNew from "../../Components/BubbleEffectNew";


const Bubble = () => {
    return (
        <>
            <div className="overflow-visible " style={{ height: "300vh" }}>
                <BubbleEffectNew />
                <h1 className="text-warning">Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga ut, nam excepturi animi mollitia vel voluptas quasi quas minima pariatur, doloremque recusandae debitis nemo iste quidem veniam vitae voluptatum omnis?Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga ut, nam excepturi animi mollitia vel voluptas quasi quas minima pariatur, doloremque recusandae debitis nemo iste quidem veniam vitae voluptatum omnis?Lorem ipsum dolor sit amet consectetur adipisicing elit. Fuga ut, nam excepturi animi mollitia vel voluptas quasi quas minima pariatur, doloremque recusandae debitis nemo iste quidem veniam vitae voluptatum omnis?</h1>
            </div>
        </>
    )
}

export default Bubble;
